<template>
  <IQOSModal style="width: 400px" size="xl" @backdropClick="close">
    <template #title>
      <div class="v1-grey-3-color">{{ $t("language_modal.head") }}</div>
    </template>

    <p class="qrw-paragraph-md v1-grey-7-color">
      {{ $t("language_modal.menu_lang_comment") }}
    </p>

    <div class="language-modal-wrapper v1-grey-3-color mt-16">
      <div class="languages">
        <div
          class="qrw-heading-xs"
          :class="active == k ? 'language active' : 'language'"
          v-for="(v, k) in languages_list"
          :key="k"
          @click="onSelect(k)"
        >
          <img :src="`/flags/${k}.png`" :alt="`Language logo (${k})`" />
          {{ v }}
        </div>
      </div>
    </div>

    <template #actions>
      <BaseButton
        variant="secondary"
        color="red-4"
        size="md"
        @click="close"
        class="w-100"
      >
        {{ $t("language_modal.cancel_btn") }}
      </BaseButton>
      <BaseButton
        variant="secondary"
        color="green-5"
        size="md"
        class="w-100"
        :disabled="!active"
        @click="chooseLan()"
      >
        {{ $t("language_modal.confirm_btn") }}
      </BaseButton>
    </template>
  </IQOSModal>
</template>

<script>
import BaseModal from "./BaseModal.vue";
import DashboardButton from "@/components/DashboardButton.vue";

import LanguageNames from "@/i18n/language_names.js";

export default {
  data() {
    return {
      active: null,
      supported_langauges: LanguageNames,
    };
  },
  props: {
    exclude: Array,
  },
  components: {
    DashboardButton,
    BaseModal,
  },
  methods: {
    onSelect(lang) {
      this.active = lang;
    },
    chooseLan(lang) {
      this.$emit("select", this.active);
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {
    languages_list() {
      const langs = Object.assign({}, this.supported_langauges);

      if (this.exclude) this.exclude.forEach((l) => delete langs[l]);

      return langs;
    },
  },
};
</script>

<style scoped>
.languages {
  display: flex;
  max-height: 50vh;
  overflow: auto;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}

.language {
  display: flex;
  align-items: center;
  background: #464646;
  cursor: pointer;
  color: #ededed;
  padding: 16px;
  height: 32px;
  flex: 0 0 calc(33%-16px);
}

.language.active {
  background: #129b81;
}

.language img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.language-modal-wrapper {
  width: auto;
}
</style>
